import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { ICustomCode } from "@/domain/entities/system/customCode.types";
import { computed, PropType } from "vue";


const __default__ = {
  name: "ReportReasonButton",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  reason: {
    type: Object as PropType<ICustomCode>,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

_useCssVars(_ctx => ({
  "7eeb1c6d-color": (color.value),
  "7eeb1c6d-colorTransparent10": (colorTransparent10.value)
}))

const props = __props;

const color = computed(() => props.reason.props?.color ?? "#7e7e7e");
const colorTransparent10 = computed(() => `${color.value}1A`);

const __returned__ = { props, color, colorTransparent10 }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})